<template>
  <div class="corp-container">

    <!-- 顶部横幅区域 -->
    <div class="main-visual-section">
      <div class="visual-image">
        <img src="https://test.eprinttools.com/files/front-end/corp.png" alt="包装印刷解决方案" />
      </div>
    </div>

    <!-- 关于我们描述区域 -->
    <section class="about-description-section">
      <div class="section-header">
        <h2>关于我们</h2>
        <p class="section-subtitle">用代码为包装印刷业注入效率与品质的生命力</p>
      </div>
      <div class="description-content">
        <p>我们不是普通的软件开发者，而是紧盯包装印刷领域的"效率优化师"与"品质守护者"。</p>
        <p>我们见过太多行业伙伴在重复操作中消耗精力，在细节误差里损耗成本。于是，我们带着对印刷工艺的敬畏和对技术的热爱，一头扎进这个领域 —— 不做泛泛的通用工具，只聚焦包装印刷的每一个核心环节，把 “提高效率、优化生产、提升质量” 这三个目标，拆成一行行精准的代码，变成一个个能落地的软件与插件。</p>
        <p>团队里既有懂印刷工艺的 “老行家”，能精准捕捉生产中的痛点；也有懂技术研发的 “极客”，能把解决方案转化为易用的工具。我们不追逐花哨的技术概念，只在乎每一款产品是否能让设计师少加班、让生产线少返工、让最终的包装作品更完美。</p>
        <p>成立至今，我们始终和行业同频：客户的每一次反馈，都是我们迭代的方向；行业的每一个新需求，都是我们创新的起点。我们坚信，好的技术不该是冰冷的代码，而应是能真正融入生产、解决问题的 “得力帮手”，这也是我们始终不变的坚持。</p>
      </div>
    </section>

    <!-- 精选工具部分 -->
    <section class="featured-tools-section">
      <div class="section-header">
        <h2>精选工具</h2>
        <div class="divider"></div>
      </div>
      <div class="tools-grid">
        <div class="tool-card" v-for="(tool, index) in toolsList" :key="tool.id"  @click="goToPluginDetails(tool.id)">
          <div class="tool-image">
            <img :src="tool.image" :alt="tool.name" />
          </div>
          <div class="tool-name">{{ tool.name }}</div>
        </div>
      </div>
    </section>

  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const goToPluginDetails = (pluginId) => {
  router.push({
    path: '/products',
    query: { id: pluginId }
  });
};

const toolsList = reactive([
  {
    id: 2,
    name: "企业级二维码插件",
    image: 'https://test.eprinttools.com/files/front-end/code.gif'
  },
  {
    id: 3,
    name: "智能刀模生成插件",
    image: 'https://test.eprinttools.com/files/front-end/mo.gif'
  },
  {
    id: 4,
    name: "美国版能效标签插件",
    image: 'https://test.eprinttools.com/files/front-end/neng.gif'
  },
  {
    id: 5,
    name: "美国版能效标签插件",
    image: 'https://test.eprinttools.com/files/front-end/huang.gif'
  }
])

</script>

<style scoped>
.corp-container {
  font-family: 'Arial', 'Microsoft YaHei', sans-serif;
  color: #333;
  line-height: 1.6;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
}

/* 顶部横幅样式 */
.main-visual-section {
  padding: 0;
  position: relative;
  width: 100%;
}

.visual-image {
  position: relative;
  width: 100%;
  height: auto; /* 自动高度以适应图片比例 */
  overflow: hidden;
}

.visual-image img {
  width: 100%;
  height: auto; /* 改为自动高度保持图片原始比例 */
  display: block;
  object-fit: contain; /* 确保完整显示图片 */
}


/* 关于我们描述区域样式 */
.about-description-section {
  padding: 20px;
  background-color: white;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.section-header h2 {
  font-size: 2.2rem;
  background: linear-gradient(45deg, #3651bf, #e267d8, #eb6e0d); /* 添加与图片中相同的渐变色 */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 15px;
  font-weight: 700;
  position: relative;
  display: inline-block;
}

.section-subtitle {
  font-size: 1rem;
  color: #2b2929;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  font-weight: 600;
}

.description-content {
  max-width: 900px;
  margin: 0 auto;
  text-align: left;
}

.description-content p {
  margin-bottom: 20px;
  font-size: 1.1rem;
  color: #555;
  line-height: 1.8;
}

/* 精选工具部分样式 */
.featured-tools-section {
  padding:  20px;
  background: linear-gradient(90deg, transparent, rgba(75, 108, 183, 0.3), transparent);
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.tool-card {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
}

.tool-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.tool-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.tool-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.tool-card:hover .tool-image img {
  transform: scale(1.05);
}

.tool-name {
  padding: 20px;
  text-align: center;
  font-weight: 600;
  color: #2d3748;
  font-size: 1.2rem;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .visual-image {
    height: 400px; /* 平板设备适当降低高度 */
  }

  .overlay-card {
    width: 300px; /* 平板设备适当减小卡片宽度 */
  }
}

@media (max-width: 768px) {

  .visual-image {
    height: auto; /* 移动端也保持自动高度 */
  }

  .visual-image img {
    object-fit: contain; /* 移动端确保完整显示 */
  }

  .about-description-section,
  .featured-tools-section {
    padding: 40px 15px;
  }

  .section-subtitle {
    font-size: 1.1rem;
    padding: 0 15px;
  }

  .section-header h2 {
    font-size: 1.8rem;
  }

  .tools-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .bottom-banner {
    padding: 40px 15px;
  }

  .bottom-banner h2 {
    font-size: 1.8rem;
  }

  .bottom-banner p {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .overlay-cards {
    padding: 15px;
  }

  .section-subtitle {
    font-size: 1rem;
  }

  .card-content {
    padding: 10px;
  }

  .card-content h3 {
    font-size: 1rem;
  }

  .card-content p {
    font-size: 0.7rem;
  }
}
</style>